"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _TestimonialCardModule = _interopRequireDefault(require("./TestimonialCard.module.css"));
var _PanelSection = _interopRequireDefault(require("../PanelSection/PanelSection"));
var TestimonialCard = function TestimonialCard(props) {
  var panelProps = props.panelProps,
    profile = props.profile,
    colors = props.colors,
    className = props.className;
  var classes = [_TestimonialCardModule["default"].TestimonialCard, className];
  return /*#__PURE__*/_react["default"].createElement(_PanelSection["default"], Object.assign({}, panelProps, {
    className: classes.join(' ')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "testimonial-card",
    className: _TestimonialCardModule["default"].cardContent
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _TestimonialCardModule["default"].comment,
    "data-testid": "testimonial-comment"
  }, props.children), /*#__PURE__*/_react["default"].createElement("span", {
    className: _TestimonialCardModule["default"].divider,
    style: {
      backgroundColor: colors.dividerColor
    }
  }), profile.profileElement ? profile.profileElement : /*#__PURE__*/_react["default"].createElement("div", {
    className: _TestimonialCardModule["default"].profile
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _TestimonialCardModule["default"].imageContainer,
    style: {
      borderColor: colors.borderColor
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: profile.img,
    alt: profile.profileName
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _TestimonialCardModule["default"].profileDetails
  }, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("em", null, profile.profileName)), /*#__PURE__*/_react["default"].createElement("p", null, profile.profileTitle)))));
};
TestimonialCard.defaultProps = {
  profile: {
    profileElement: undefined,
    profileName: '',
    profileTitle: '',
    img: ''
  },
  colors: {
    dividerColor: 'black',
    borderColor: 'black'
  },
  panelProps: {
    backgroundColor: undefined,
    shadow: false,
    shadowColor: undefined
  },
  className: ''
};
var _default = TestimonialCard;
exports["default"] = _default;